<template>
  <div class="footer-wrapper">
    <footer class="humo-footer">
      <a href="#" data-role="privacy-settings">Cookie-instellingen</a>
      <a class="footer-link" href="https://humo.be">© Humo.be</a>
    </footer>
  </div>
</template>

<script setup></script>
